import React, { useContext, useRef, useLayoutEffect } from 'react';
import { ThemeProvider } from 'styled-components';
import BasicIcon from '../BasicIcon/BasicIcon';
import { ThemeContext } from '../ThemeProvider/ThemeProvider';
import { BodyContainer, ToastContainer } from './styles';
import { animation } from './Animations';
import { ToastIcon, ToastPropsType } from './types';

const Toast: React.FC<ToastPropsType> = ({ index, toast }) => {
  const { actualTheme } = useContext(ThemeContext);
  const toastRef = useRef();

  useLayoutEffect(() => {
    const ctx = animation(toastRef);
    return () => ctx.revert();
  }, []);

  return (
    <ThemeProvider theme={actualTheme}>
      <ToastContainer ref={toastRef} type={toast.type} index={index}>
        <BasicIcon
          name={ToastIcon[toast.type]}
          color={actualTheme.toast.types[toast.type].iconColor}
        />
        <BodyContainer>{toast.body}</BodyContainer>
      </ToastContainer>
    </ThemeProvider>
  );
};

export default Toast;
